import Swiper from "swiper/bundle";

const iconTextSlider = document.querySelector(".multi-col-testimonial-slider");
if (iconTextSlider) {
  const swiper = new Swiper(iconTextSlider, {
    direction: "horizontal",
    loop: false,
    spaceBetween: 24,
    centeredSlides: false,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      400: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}